import type { SVGProps } from 'react'
const SvgSyImage = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				fillRule="evenodd"
				d="M7.65 2c-1.681 0-3.132.613-4.127 1.68S2 6.232 2 7.898v8.153c0 1.665.526 3.152 1.52 4.219.993 1.067 2.444 1.681 4.13 1.681h8.65c1.687 0 3.14-.615 4.136-1.681s1.525-2.553 1.525-4.22V7.899c0-1.666-.53-3.152-1.525-4.218C19.439 2.613 17.987 2 16.3 2zm0 1.5h8.65c1.335 0 2.336.452 3.04 1.205s1.12 1.84 1.12 3.193v8.153c0 1.353-.416 2.442-1.12 3.195-.704.754-1.706 1.205-3.04 1.205H7.65c-1.333 0-2.332-.452-3.033-1.205S3.5 17.406 3.5 16.051V7.898c0-1.353.416-2.442 1.12-3.195S6.321 3.5 7.65 3.5"
				clipRule="evenodd"
			/>
			<path
				d="M15.154 11.56a2.43 2.43 0 0 0-1.646.872l-1.153 1.396-.798.967-.27.324-.062.076a.67.67 0 0 1-.963-.011s-.231-.233-.463-.47l-.322-.325c-.09-.09-.113-.117-.157-.16l-.017-.018a2.163 2.163 0 0 0-3.037.092l-1.53 1.613a.75.75 0 0 0 .03 1.059.75.75 0 0 0 1.06-.028l1.528-1.613.001-.002a.64.64 0 0 1 .92-.027l.133.134.322.327c.233.235.461.47.461.47.838.853 2.23.866 3.084.032.087-.085.049-.051.057-.061l.027-.031.08-.098.272-.326.8-.969 1.155-1.398a.925.925 0 0 1 1.313-.13c.015.017.033.034.058.06l.256.261.76.776c.548.56 1.09 1.117 1.09 1.117a.75.75 0 0 0 1.06.013.75.75 0 0 0 .014-1.06s-.543-.557-1.092-1.12l-.76-.777-.26-.263-.08-.082c-.02-.021.043.029-.084-.077l-.002-.003a2.43 2.43 0 0 0-1.785-.54"
				opacity={0.4}
			/>
			<path
				fillRule="evenodd"
				d="M8.559 6.629a2.515 2.515 0 0 0-2.504 2.504 2.515 2.515 0 0 0 2.504 2.504 2.515 2.515 0 0 0 2.504-2.504 2.517 2.517 0 0 0-2.504-2.504m0 1.5a.99.99 0 0 1 1.004 1.004.99.99 0 0 1-1.004 1.004.99.99 0 0 1-1.004-1.004.99.99 0 0 1 1.004-1.004"
				clipRule="evenodd"
				opacity={0.4}
			/>
		</g>
	</svg>
)
export default SvgSyImage
